"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles/makeStyles.js"));

var _XIcon = _interopRequireDefault(require("../../assets/Icons/XIcon"));

var _Colors = _interopRequireDefault(require("../../styles/Colors"));

var _InfoIcon = _interopRequireDefault(require("../../assets/Icons/InfoIcon"));

var _WarningIcon = _interopRequireDefault(require("../../assets/Icons/WarningIcon"));

var _CheckIcon = _interopRequireDefault(require("../../assets/Icons/CheckIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var severityColor = {
  info: _Colors.default.textElementGrey,
  success: _Colors.default.acceptGreen,
  error: _Colors.default.warning
};
var useStyle = (0, _makeStyles.default)({
  messageContainer: function messageContainer(_ref) {
    var severity = _ref.severity,
        margin = _ref.margin;
    return {
      boxSizing: 'border-box',
      height: '96px',
      width: '304px',
      position: 'relative',
      padding: '8px 12px',
      borderLeft: "8px solid ".concat(severityColor[severity]),
      boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.1)',
      borderRadius: '5px',
      backgroundColor: 'white',
      margin: margin
    };
  },
  toasterTitleContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  toasterTitle: {
    marginLeft: '4px',
    width: '200px',
    whiteSpace: 'nowrap',
    fontFamily: 'Oswald',
    fontSize: '18px',
    lineHeight: '18px',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  toasterMsg: {
    width: '240px',
    height: '32px',
    margin: '5px 5px',
    fontFamily: 'Lato',
    fontSize: '13px',
    lineHeight: '16px',
    letterSpacing: '0.5px',
    color: _Colors.default.textElementGrey,
    overflow: 'hidden'
  },
  closeIcon: {
    position: 'absolute',
    top: '8px',
    right: '8px',
    cursor: 'pointer'
  }
});

var ToastContent = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var header = props.header,
      message = props.message,
      severity = props.severity,
      onClose = props.onClose,
      _props$margin = props.margin,
      margin = _props$margin === void 0 ? '0' : _props$margin,
      id = props.id;

  var _useStyle = useStyle({
    severity: severity,
    margin: margin
  }),
      closeIcon = _useStyle.closeIcon,
      messageContainer = _useStyle.messageContainer,
      toasterTitle = _useStyle.toasterTitle,
      toasterMsg = _useStyle.toasterMsg,
      toasterTitleContainer = _useStyle.toasterTitleContainer;

  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    className: messageContainer,
    id: id,
    "data-testid": props['data-testid']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: toasterTitleContainer
  }, severity === 'info' && /*#__PURE__*/_react.default.createElement(_InfoIcon.default, {
    fill: "black"
  }), severity === 'error' && /*#__PURE__*/_react.default.createElement(_WarningIcon.default, {
    fill: "black"
  }), severity === 'success' && /*#__PURE__*/_react.default.createElement(_CheckIcon.default, {
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: toasterTitle
  }, header || severity)), /*#__PURE__*/_react.default.createElement("div", {
    className: toasterMsg
  }, message), /*#__PURE__*/_react.default.createElement("div", {
    className: closeIcon,
    onClick: function onClick(e) {
      return onClose && onClose(e, 'clickaway');
    },
    role: "none"
  }, /*#__PURE__*/_react.default.createElement(_XIcon.default, {
    fill: "black"
  })));
});

var _default = ToastContent;
exports.default = _default;